import { range } from 'utils/lerp';

import { ALPHABET } from './constants';
import {
  IAftercareLandingPage,
  TAftercareCTA,
  TAftercareRelatedArticle,
} from './types';

export const groupGenera = ({
  genus,
  relatedContent,
}: Pick<IAftercareLandingPage, 'genus' | 'relatedContent'>) =>
  ALPHABET.map((letter) => {
    return {
      letter,
      genera: genus?.filter(({ name, botanicalName }) =>
        (name || botanicalName).toUpperCase().startsWith(letter),
      ),
      articles:
        relatedContent
          ?.filter(({ letter: contentLetter }) => contentLetter === letter)
          .filter(
            (article): article is TAftercareRelatedArticle =>
              article._type === 'relatedArticle',
          ) || [],
      ctas:
        relatedContent
          ?.filter(({ letter: contentLetter }) => contentLetter === letter)
          .filter(
            (article): article is TAftercareCTA => article._type === 'cta',
          ) || [],
    };
  });

export const createFallbackMetaDescription = (name: string = ''): string => {
  const descriptionTemplates = [
    'Read our guide on how to keep your %s alive',
    "Learn how to help your %s thrive with Sproutl's Aftercare guide",
    'Everything thing you need to know to look after your %s',
    'Read our fool-proof guide to growing %s',
    'Caring for a %s? Look no further than Sproutl Aftercare',
    'How to grow %s with Sproutl Aftercare',
    'All you need to know to look after %s with Sproutl Aftercare',
    'Learn what every %s needs to thrive with Sproutl Aftercare',
    "Keep your %s alive with Sproutl's Aftercare guide",
    "Find out how to look after %s with Sproutl's Aftercare guide",
    'Keep your %s healthy and strong with Sproutl Aftercare',
    "Want to know more about %s? Read Sproutl's helpful Aftercare guide",
  ];

  // Convert the first letter of the name into a character code
  const firstLetterAsNumber = name.toLowerCase()?.[0].charCodeAt(0) - 97;

  // Map the letter to an index for the templates
  const index = Math.floor(
    range(0, 26, 0, descriptionTemplates.length, firstLetterAsNumber),
  );

  return (descriptionTemplates[index] || descriptionTemplates[0]).replace(
    '%s',
    name,
  );
};
